export enum STEPS {
  // 步骤1
  STEP0,
  // 步骤2
  STEP1,
  // 步骤3
  STEP2,
  // 步骤4
  STEP3,
}

export const TEAM_STARTER_PAY_ACCOUNT_KEY = 'teamStarterPayAccount'; // 支付入门版团队账号 session存储所用的key

export const TEAM_TASTE_PAY_YANBI_KEY = 'teamTastePayYanbi'; // 体验版创建后yanbi信息 session存储所用的key

export const quantityOptions = () => {
  const { $t } = useNuxtApp();

  return [
    { label: $t('num-ren-yi-xia', ['5']), value: $t('num-ren-yi-xia', ['5']) },
    { label: $t('num-ren', ['5-10']), value: $t('num-ren', ['5-10']) },
    { label: $t('num-ren', ['10-50']), value: $t('num-ren', ['10-50']) },
    {
      label: $t('num-ren-yi-shang', ['50']),
      value: $t('num-ren-yi-shang', ['50']),
    },
  ];
};
